import { callApi } from 'services/util';

import { catchError, isEmpty, isNotEmpty, isString, unique } from 'util/utils';

import { BASE_URL } from 'constants/Common';
import { EXPORT_EXCEL } from 'constants/apiConstant';

import { LoaderService } from './LoaderService';

export class StoneService {
  static async exportAsExcel(options) {
    LoaderService.startLoading();
    await catchError(async () => {
      const idList = unique(options?.list?.map?.((stone) => stone?.id ?? stone)?.filter?.(isNotEmpty) ?? []);

      const fileName = isString(options?.sheetName) && !isEmpty(options?.sheetName) ? options?.sheetName : undefined;
      const filter =
        options?.filter?.viewType && isEmpty(idList) ? { isFm: { nin: ['CERT', 'ELIG'] } } : options?.filter ?? {};
      const summary = options?.summary ?? false;
      const viewType = options?.filter?.viewType && isEmpty(idList) ? 2 : undefined;

      const request = { allSummary: summary, filter: filter, id: idList, sheetName: fileName, viewType };
      const [err, res] = await callApi({ ...EXPORT_EXCEL, request });

      if (!err && isString(res.data.data)) window.open(`${BASE_URL}/data${res.data.data}`, 'Download');
    });
    LoaderService.stopLoading();
  }
}
